import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

import axios from "axios";
import vueAxios from "vue-axios";

// axios.defaults.baseURL = "https://api2.wingjoy.cn/wingjoy";
axios.defaults.baseURL = "https://api.wing2life.com/wingjoy";
Vue.use(vueAxios, axios);

// 引入 bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";

//引入 font-awesome
import "font-awesome/css/font-awesome.min.css";
// 完整引入 ElementUI
import ElementUI from "element-ui";

Vue.use(ElementUI);
// 引入 ElementUI 的样式文件
import "element-ui/lib/theme-chalk/index.css";
// 引入 animate.css
import animated from "animate.css";

Vue.use(animated);

import MetaInfo from "vue-meta-info";

// 注册 vue-meta-info
Vue.use(MetaInfo);

// noinspection JSUnusedGlobalSymbols
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
